import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { format, isValid, parseISO } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';

const parseDate = value => {
  const date = value ? parseISO(value) : null;
  return date && isValid(date) ? date : null;
};

export default function DatePicker({ id, value, onChange, minDate, maxDate, withPortal = false }) {
  const parsed = value ? parseISO(value) : undefined;
  const selected = parsed && isValid(parsed) ? parsed : null;
  return (
    <ReactDatePicker
      id={id}
      selected={selected}
      minDate={parseDate(minDate)}
      maxDate={parseDate(maxDate)}
      withPortal={withPortal}
      portalId={withPortal ? `${id}-calendar-portal` : undefined}
      // Keep the API's date-only value without converting the selected day to UTC.
      onChange={date => onChange(date ? format(date, 'yyyy-MM-dd') : '')}
      dateFormat="dd-MM-yyyy"
      placeholderText="DD-MM-YYYY"
      strictParsing
      isClearable
      clearButtonTitle="Clear date"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      todayButton="Today"
      wrapperClassName="w-full mt-1.5"
      className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 pr-8 text-sm"
      popperClassName="z-50"
      calendarClassName="puja-datepicker-calendar"
    />
  );
}
